import React from 'react'
import './ProductDetails.css'

function ProductDeteilsLoading() {
  return (
<div className='Loading-item'>
<div className='item-Detailes'>
<div className="Container">
<div className="imgs_item skiles"></div>

<div className="Deteils-item">

    <h5 className='loading_TextDetailsItem skiles'></h5>
    <h5 className='loading_TextDetailsItem skiles'></h5>
    <h5 className='loading_TextDetailsItem skiles'></h5>
    <h5 className='loading_TextDetailsItem skiles'></h5>
    <h5 className='loading_TextDetailsItem skiles'></h5>
   
</div>

</div>
</div>
</div>
   
  )
}

export default ProductDeteilsLoading